import React, {Component} from 'react';
import {ControlLabel, FormGroup} from 'react-bootstrap';
import {actions, Errors} from 'react-redux-form';
import CKEditor from 'react-ckeditor-component';
import './styles.css';

import store from './../../../../store';

class Editor extends Component {
  onChange = (value) => {
    const htmlCode = value.toString('html');
    store.dispatch(actions.change(this.props.field, htmlCode));

    if (this.props.onChange) {
      this.props.onChange(htmlCode);
    }
  };

  render() {
    return (
      <FormGroup>
        <ControlLabel>
          Body*
        </ControlLabel>
        <CKEditor
          activeClass={this.props.field}
          config={{
            toolbar:
              [
                {
                  name: 'clipboard',
                  items: ['Cut', 'Copy', 'Paste', 'PasteText', 'MediaEmbed', 'PasteFromWord', '-', 'Undo', 'Redo']
                },
                {
                  name: 'editing',
                  items: ['Find', 'Replace', '-', 'SelectAll']
                },
                {
                  name: 'tools',
                  items: ['Maximize', '-', 'About']
                },
                {
                  name: 'document',
                  items: ['Source']
                },
                '/',
                {
                  name: 'paragraph',
                  items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv',
                    '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
                },
                {
                  name: 'links',
                  items: ['Link', 'Unlink', 'Anchor']
                },
                {
                  name: 'insert',
                  items: ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'Iframe']
                },
                '/',
                {
                  name: 'basicstyles',
                  items: [
                    'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'
                  ]
                },
                {
                  name: 'styles',
                  items: ['Styles', 'Format', 'Font', 'FontSize']
                },
                {
                  name: 'colors',
                  items: ['TextColor', 'BGColor']
                },
              ],
            extraPlugins: 'mediaembed,find,selectall,div,justify,smiley,specialchar,iframe,font,colorbutton',
            extraAllowedContent: 'iframe[fullscreen,allowfullscreen]',
            removedButtons: '',
          }}
          content={this.props.content}
          events={{
            change: event => this.onChange(event.editor.getData())
          }}
          scriptUrl="/api/ckeditor/ckeditor.js"
        />
        <Errors
          className="errors"
          model={this.props.field}
          show={{
            touched: true,
            focus: false
          }}
        />

      </FormGroup>
    );
  }
}

export default Editor;



// WEBPACK FOOTER //
// ./src/components/admin/notifications/edit/editor.jsx